exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-list-item{\n    margin: 5px;\n}", ""]);

